(function () {
  // This script is included once per product card, so it can execute many times
  // on a grid page. Guard so the document-level listeners are only ever attached once,
  // otherwise each click fires N times (e.g. +N on the quantity stepper).
  if (window.__factor2ProductCardInit) return;
  window.__factor2ProductCardInit = true;

  const PENDING_KEY = 'productCardPendingAdd';

  function handlePendingAdd() {
    const pending = sessionStorage.getItem(PENDING_KEY);
    if (!pending) return;

    let data;
    try {
      data = JSON.parse(pending);
    } catch (e) {
      sessionStorage.removeItem(PENDING_KEY);
      return;
    }

    sessionStorage.removeItem(PENDING_KEY);

    if (!data.variantId) return;

    // Never add without a confirmed valid waiver. The pending add can be triggered by a
    // login redirect or a dismissed modal, so re-check the signature before adding.
    var config = window.Factor2Affidavit;
    if (!config || !config.customerId || !config.customerHmac) return;

    var statusUrl =
      config.apiUrl +
      '/api/affidavit-status?customerId=' +
      encodeURIComponent(config.customerId) +
      '&productId=' +
      encodeURIComponent(data.productId) +
      '&hmac=' +
      encodeURIComponent(config.customerHmac);

    fetch(statusUrl)
      .then(function (r) {
        return r.json();
      })
      .then(function (status) {
        if (status && status.ready === true) {
          addPendingToCart(data);
        } else {
          var reopen = new CustomEvent('openAffidavitModal', {
            detail: {
              productId: data.productId,
              productCodes: data.productCode,
            },
          });
          document.dispatchEvent(reopen);
        }
      })
      .catch(function (err) {
        console.error('Affidavit status check failed:', err);
      });
  }

  function addPendingToCart(data) {
    const body = {
      items: [{ id: parseInt(data.variantId, 10), quantity: data.quantity || 1 }],
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          fetch('/cart.js')
            .then(function (r) {
              return r.json();
            })
            .then(function () {
              var event = new CustomEvent('cart:refresh');
              document.dispatchEvent(event);
              if (cartDrawer.querySelector('.drawer')) {
                cartDrawer.querySelector('.drawer').removeAttribute('hidden');
              }
              window.location.reload();
            });
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        console.error('Auto-add after affidavit failed:', err);
      });
  }

  function initQuantityButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action="increase"], [data-action="decrease"]');
      if (!btn) return;

      var wrapper = btn.closest('.quick-add-form__quantity-wrapper');
      if (!wrapper) return;

      var input = wrapper.querySelector('.quick-add-form__qty-input');
      if (!input) return;

      var current = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      var max = input.max ? parseInt(input.max, 10) : Infinity;
      var step = parseInt(input.step, 10) || 1;

      if (btn.getAttribute('data-action') === 'increase') {
        var next = current + step;
        if (next <= max) input.value = next;
      } else {
        var prev = current - step;
        if (prev >= min) input.value = prev;
      }
    });
  }

  function initAffidavitButtons() {
    document.addEventListener('click', function (e) {
      var button = e.target.closest('[data-affidavit-product]');
      if (!button) return;

      var hasValidWaiver = button.getAttribute('data-has-valid-waiver') === 'true';
      if (hasValidWaiver) return;

      e.preventDefault();
      e.stopPropagation();

      var form = button.closest('form');
      if (form) {
        form.addEventListener(
          'submit',
          function (se) {
            se.preventDefault();
          },
          { once: true },
        );
      }

      var productId = button.getAttribute('data-product-id');
      var variantId = button.getAttribute('data-variant-id');
      var productCode = button.getAttribute('data-product-code');
      var isLoggedIn = button.getAttribute('data-customer-logged-in') === 'true';

      var qtyInput = form ? form.querySelector('.quick-add-form__qty-input') : null;
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var moq = parseInt(button.getAttribute('data-moq'), 10) || 1;
      if (moq > quantity) quantity = moq;

      var pendingData = {
        productId: productId,
        variantId: variantId,
        productCode: productCode,
        quantity: quantity,
      };

      sessionStorage.setItem(PENDING_KEY, JSON.stringify(pendingData));

      if (!isLoggedIn) {
        window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
        return;
      }

      var event = new CustomEvent('openAffidavitModal', {
        detail: {
          productId: productId,
          productCodes: productCode,
        },
      });
      document.dispatchEvent(event);
    });
  }

  function init() {
    handlePendingAdd();
    initQuantityButtons();
    initAffidavitButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
